export const APP_CONFIG: {
	adminApiURL: string;
	externalApiURl: string;
	hubsURL: string;
	appId: string;
} = (window as any).config;
